import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { toast } from 'react-toastify';
import DateInput from '../components/Forms/DateInput';
import TimeInput12 from '../components/Forms/TimeInput12';
import { tagCommentForWorkRegister } from '../../services/WorkRegisterService';
import '../Documents/commonstyle.css';
import './workRegister.css';

function formatDateForApi(date) {
  if (!date) return '';
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function todayInputValue() {
  return formatDateForApi(new Date());
}

export default function WorkRegisterTagModal({ show, onHide, commentId, onSuccess }) {
  const [workDate, setWorkDate] = useState(todayInputValue());
  const [startTime, setStartTime] = useState('');
  const [endTime, setEndTime] = useState('');
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setWorkDate(todayInputValue());
      setStartTime('');
      setEndTime('');
    }
  }, [show, commentId]);

  const handleSubmit = async () => {
    if (!commentId) {
      toast.error('Comment is missing an id.');
      return;
    }
    if (!workDate) {
      toast.error('Please select a date.');
      return;
    }

    const userData = JSON.parse(localStorage.getItem('user') || '{}');
    const corporateUserId = userData?.id;
    if (!corporateUserId) {
      toast.error('User session not found.');
      return;
    }

    try {
      setSubmitting(true);
      await tagCommentForWorkRegister({
        comment_id: commentId,
        work_register_user_id: corporateUserId,
        work_register_date: workDate,
        start_time: startTime || null,
        end_time: endTime || null,
      });
      toast.success('Added to Work Register');
      onSuccess?.();
      onHide();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to tag for Work Register');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered dialogClassName="work-register-modal-dialog">
      <Modal.Header closeButton>
        <Modal.Title>Add to Work Register</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted small mb-3">
          Add this comment as a reminder in your Work Register (your register, not the comment author&apos;s).
        </p>
        <div className="mb-3">
          <label className="form-label">Date</label>
          <DateInput
            type="date"
            className="form-control"
            value={workDate}
            onChange={(e) => setWorkDate(e.target.value)}
          />
        </div>
        <div className="row g-2">
          <div className="col-6">
            <label className="form-label">Start time</label>
            <TimeInput12
              className="form-control"
              value={startTime}
              onChange={(e) => setStartTime(e.target.value)}
            />
          </div>
          <div className="col-6">
            <label className="form-label">End time</label>
            <TimeInput12
              className="form-control"
              value={endTime}
              onChange={(e) => setEndTime(e.target.value)}
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button className="doc-form-cancel-btn" onClick={onHide} disabled={submitting}>
          Cancel
        </Button>
        <Button className="doc-form-submit-btn" onClick={handleSubmit} disabled={submitting}>
          {submitting ? 'Saving…' : 'Add to Register'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
